import React, { useState } from 'react';
import './Newsletter.css';

function Newsletter() {
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [status, setStatus] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        const response = await fetch('https://us-central1-hauteu-ar.cloudfunctions.net/addSubscriber', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, name, subscribe: true, message: "Subscribed via Newsletter page" }),
        });

        //const result = await response.json();
        if (response.ok) {
            setStatus('✅ Thank you for subscribing!');
            setEmail('');
            setName('');
        } else {
            setStatus('❌ Something went wrong. Please try again.');
        }
    };

    return (
        <div className="newsletter-container">
            <h1 className="newsletter-title">Subscribe to the Haute-U AR Newsletter</h1>
            <p className="newsletter-subtext">
                Get the latest updates on AR fashion, product launches, insider news, and more!
            </p>

            <form className="newsletter-form" onSubmit={handleSubmit}>
                <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                />
                <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <button type="submit">Subscribe</button>
                {status && <p className="newsletter-status">{status}</p>}
            </form>
        </div>
    );
}

export default Newsletter;
